import { useSelector } from 'react-redux'

import { GAME_CARD_VARIANTS } from 'constants/uiConfig'
import GameCardV1 from 'components/GameCards/GameCardV1'
import GameCardV2 from 'components/GameCards/GameCardV2'
import GameCardV3 from 'components/GameCards/GameCardV3'

/**
 * A factory component that renders different versions of the `GameCard`
 * component based on the `gameCardVariant` value
 *
 * @param {object} props - The props to be passed to the `GameCard` or `GameCardV2` component.
 * @returns {JSX.Element|null} The rendered `GameCard` or `GameCardV2` component, or null if no variant matches.
 */
const GameCardFactory = (props) => {
  const gameCardVariant = useSelector(state => state?.uiConfig?.general?.gameCardVariant)
  const disableDemoPlay = useSelector(state => state?.uiConfig?.general?.disableDemoPlay)

  const additionalProps = {
    disableDemoPlay
  }

  if (gameCardVariant === GAME_CARD_VARIANTS.V1) {
    return (
      <GameCardV1 {...props} {...additionalProps} />
    )
  } else if (gameCardVariant === GAME_CARD_VARIANTS.V2) {
    return (
      <GameCardV2 {...props} {...additionalProps} />
    )
  } else if (gameCardVariant === GAME_CARD_VARIANTS.V3) {
    return (
      <GameCardV3 {...props} {...additionalProps} />
    )
  }

  return null
}

export default GameCardFactory
